import { AnacapriModule } from '@anacapri/angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';

import { AppComponent } from './app/app.component';
import { ROUTES } from './app/app.routing';
import { AppErrorHandler } from './app/shared/errors/error-handling/app.error.handler';
import { AppPropertiesService } from './app/shared/services/app-properties/app-properties.service';
import { INTERCEPTORS } from './environments/environment';

/**
 * Bootstrap the app.
 */
bootstrapApplication(AppComponent, {
	providers: [
		provideRouter(ROUTES),
		provideAnimations(),
		provideHttpClient(withInterceptors(INTERCEPTORS)),
		importProvidersFrom(AnacapriModule.forRoot()),
		{
			provide: ErrorHandler,
			useClass: AppErrorHandler
		},
		{
			provide: APP_INITIALIZER,
			useFactory: (service: AppPropertiesService) => () => service.fetchAppProperties(),
			deps: [AppPropertiesService],
			multi: true
		}
	]
});
